class EnhancedEvents {
  
  static init (options) {
    EnhancedEvents.list = []
  }
  
  static add (event) {
    EnhancedEvents.list.push(event)

    if (typeof EnhancedEvents.onAdd === 'function') {
      EnhancedEvents.onAdd(event)
    }
  }
}

export default EnhancedEvents
